export const isWACError = (error: unknown): boolean => String(error).includes('PendingWAC');

export const isPermissionDeniedError = (error: unknown): boolean =>
  String(error).includes('PermissionDenied');
